import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { SyncfusionChartSettingsHelper } from '@morningstar/shared/util';
import { AccumulationChart } from '@syncfusion/ej2-charts';
import { CategoryService } from 'apps/wsg/src/app/shared/categories/category.service';
import { combineLatest } from 'rxjs';
import { delay, filter, map, startWith, switchMap, tap } from 'rxjs/operators';
import { DashboardBaseComponent } from '../../dashboard-base/dashboard-base.component';
import { FixedChargesByCategoryService } from './fixed-charges-by-category.service';

@Component({
  selector: 'wsg-fixed-charges-by-category',
  templateUrl: './fixed-charges-by-category.component.html',
  styleUrls: ['../../dashboard.scss', './fixed-charges-by-category.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FixedChargesByCategoryComponent extends DashboardBaseComponent implements AfterViewInit {

  // == CONSTANTS =======================================================

  title = 'Fixed Charges';
  chartId = 'fixedChargesByCategory';
  @ViewChild('pie') pieChart: AccumulationChart

  chartSettings = SyncfusionChartSettingsHelper.getPieChartSettings();

  // == STATE ===========================================================

  categories$ = this.categoryService.get();

  form = this.formBuilder.group({
    location: ''
  });

  // == INTERMEDIATE ====================================================

  location$ = this.form.get('location').valueChanges.pipe(
    startWith('')
  );

  fixedCharges$ = this.location$.pipe(
    filter(location => !!location),
    switchMap(location => this.fixedChargesByCategoryService.get(location)),
  );

  formattedFixedCharges$ = combineLatest([this.fixedCharges$, this.categories$]).pipe(
    map(([revenue, categories]) => {
      revenue.forEach(r => r.category = categories.find(c => c.id === r.category).description);
      return revenue;
    }),
    tap(revenue => {
      this.pieChart.dataSource = revenue;
      this.pieChart.refresh()
    })
  );

  // == LIFECYCLE =======================================================

  constructor(private fixedChargesByCategoryService: FixedChargesByCategoryService, 
              private formBuilder: FormBuilder,
              private categoryService: CategoryService,
              protected storageService: StorageService) {
    super(storageService);
  }

  ngAfterViewInit() {
    this.baseSubscription.add(this.theme$.pipe(
      delay(50),
      tap(_ => this.pieChart.refresh())
    ).subscribe())
  }
}
